// Document DTO and types for client usage
import React from "react";

export enum FileCategory {
  Prescription = 1,
  LabReport = 2,
  InsuranceCard = 3,
  MedicalBill = 4,
  DischargeSummary = 5,
  Other = 0,
  Identity = 6,
  EmergencyCard = 7,
} // 'Other' is included for uncategorized/other documents

export enum DocumentStatus {
  Pending = 0,
  Processing = 1,
  Processed = 2,
  Failed = 3,
  Uncategorized = 4,
}

export enum DocumentSource {
  APP = "app",
  WHATSAPP = "whatsapp",
  EMAIL = "email",
  CAMERA = "camera",
  GALLERY = "gallery",
  FILES = "files",
}

export interface Media {
  fileName?: string;
  file_name?: string;
  mimeType?: string;
  mime_type?: string;
  size?: string | number;
  fileKey?: string;
  file_key?: string;
  url?: string;
  thumbnail?: string;
  uploadTime?: number;
}

export interface DocumentMedia {
  fileName?: string;
  file_name?: string;
  mimeType?: string;
  mime_type?: string;
  size?: string | number;
  fileKey?: string;
  file_key?: string;
  url?: string;
  thumbnail?: string;
  uploadTime?: number;
}

// Ensure DocumentMedia interface covers both naming conventions
export interface Media {
  fileName?: string;
  file_name?: string;
  mimeType?: string;
  mime_type?: string;
  size?: string | number;
  fileKey?: string;
  file_key?: string;
  url?: string;
  thumbnail?: string;
  uploadTime?: number;
}

export interface Document {
  _id?: string;
  id?: string;
  uid?: string;
  displayName?: string;
  category?: FileCategory | string;
  media?: Media | DocumentMedia;
  created_at?: string;
  createdAt?: string;
  status?: DocumentStatus | string;
  insights?: boolean;
  notes?: string;
  isPrivate?: boolean;
  isImportant?: boolean;
  availableOffline?: boolean;
  fileKey?: string;
  fileName?: string;
  source?: DocumentSource;
}

export interface DocumentDTO {
  _id?: string;
  id?: string;
  displayName?: string;
  category?: FileCategory;
  documentDate?: string;
  notes?: string;
  isPrivate?: boolean;
  isImportant?: boolean;
  availableOffline?: boolean;
  media?: Media | DocumentMedia;
  fileKey?: string;
  fileName?: string;
}

export interface DocumentsResponse {
  data: Document[];
  total: number;
  page?: number;
  pageSize?: number;
}

export interface CreateDocumentDto {
  displayName?: string;
  media?: Media;
  category?: FileCategory;
  status?: DocumentStatus;
  tags?: string[];
  notes?: string;
  documentDate?: string | Date;
  availableOffline?: boolean;
  isPrivate?: boolean;
  isImportant?: boolean;
  summary?: any;
  insights?: boolean;
  source?: DocumentSource;
}

export const DocumentStatusLabel: Record<DocumentStatus, string> = {
  [DocumentStatus.Pending]: "Pending",
  [DocumentStatus.Processing]: "Processing",
  [DocumentStatus.Processed]: "Processed",
  [DocumentStatus.Failed]: "Failed",
  [DocumentStatus.Uncategorized]: "Uncategorized",
};

export const fileCategoryLabels: Record<FileCategory, string> = {
  [FileCategory.Prescription]: "Prescription",
  [FileCategory.DischargeSummary]: "Procedure",
  [FileCategory.LabReport]: "Report",
  [FileCategory.MedicalBill]: "Bill",
  [FileCategory.InsuranceCard]: "Insurance",
  [FileCategory.Identity]: "Identity",
  [FileCategory.EmergencyCard]: "Emergency Card",
  [FileCategory.Other]: "Other", // For documents not matching other categories
};

export function getFileCategoryLabel(
  category: FileCategory | null | undefined
): string {
  if (category == null) return "All Types";
  return fileCategoryLabels[category as FileCategory] || String(category);
}

export interface DocumentUploadOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

export interface MDocumentUploadOptionsProps {
  open: boolean;
  onClose: () => void;
  onFilesChange?: (files: any[]) => void;
  onSelectOption?: (option: DocumentUploadOption) => void;
  disabled?: boolean;
  className?: string;
}
